// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uZHUD","content":"styles_content__38B3s","tableWrap":"styles_tableWrap__2uPae"};